import React, { useState } from "react";
import { Box, Button } from "@mui/joy";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { useNavigate } from "react-router-dom";
import AdminEventForm, { AdminEventFormValues } from "../components/Admin/AdminEventForm";
import { createAdminEvent } from "../api";
import PageHero from "../components/common/PageHero";

export default function AdminEventCreatePage() {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (data: AdminEventFormValues) => {
    setIsSubmitting(true);
    try {
      await createAdminEvent(data);
      navigate("/events");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Box>
      <PageHero
        eyebrow="Festival planning"
        title="Create a new seva event"
        description="Craft the invitation, timing, and seva focus so devotees know how to join your upcoming celebration."
        actions={
          <>
            <Button
              variant="soft"
              color="neutral"
              startDecorator={<CalendarMonthRoundedIcon />}
              onClick={() => navigate("/events")}
            >
              View all events
            </Button>
            <Button
              variant="plain"
              color="neutral"
              startDecorator={<ArrowBackRoundedIcon />}
              onClick={() => navigate(-1)}
            >
              Go back
            </Button>
          </>
        }
      />

      <AdminEventForm
        onSubmit={handleSubmit}
        onCancel={() => navigate("/events")}
        isSubmitting={isSubmitting}
      />
    </Box>
  );
}
